import React,
{
  useEffect,
  useState,
} from 'react';

import {
  useTranslation,
} from 'react-i18next';

import {
  companyDrinksArray,
} from '@noitada/shared/arrays/company-drinks.array';

import {
  Colors,
} from '@noitada/shared/constants';

import {
  TranslateConfig,
} from '@noitada/shared/translations';

import {
  validateString,
} from '@noitada/shared/utils/string.utils';

import {
  Chip,
} from '../../../../../../components/Composh/web';

import {
  DetailsSectionView,
  SubtitleDetails,
} from '../../../../../../styles/styled.layout';

import {
  DetailsOpenBarContent,
} from './styled';



export interface IProps {
  openBar: string;
}



const DetailsOpenBar: React.FC<IProps> = (props: IProps) => {
  const { t: translate } = useTranslation();


  const [availableList, setAvailableList] = useState<Array<any>>([]);



  function renderAvailables() {
    const itemAvailableList: any = [];

    if (validateString(props.openBar)) {
      const availablesEdit: Array<string> = props.openBar?.split(', ') || [];

      if (availablesEdit.length > 0) {
        availablesEdit.forEach((item: string) => {
          const labelUser = companyDrinksArray.find((itemValue) => itemValue.value === item);

          if (labelUser) {
            itemAvailableList.push(item);
          }
        });
      }
    }

    setAvailableList(itemAvailableList);
  }


  function renderItemList(item: string, index: number) {
    const drinkFind = companyDrinksArray.find((findItem) => findItem?.value === item);

    return (

      <Chip
        key={index}
        selected
        title={translate(drinkFind?.label || '')}
        backgroundColor={Colors.grayLight}
        textColor={Colors.primary}
        selectedBackgroundColor={Colors.cardBackground}
        selectedTextColor={Colors.white}
      />

    );
  }



  useEffect(() => {
    renderAvailables();
  }, [props.openBar]);



  return availableList.length > 0
    ? (
      <DetailsSectionView>

        <SubtitleDetails>
          {translate(TranslateConfig.EVENT_OPENBAR)}
        </SubtitleDetails>



        <DetailsOpenBarContent>
          {availableList.map((item: string, index: number) => (
            renderItemList(item, index)
          ))}
        </DetailsOpenBarContent>

      </DetailsSectionView>
    )
    : null;
};



export default DetailsOpenBar;
